<script setup>
import { reactive, ref, onMounted } from "vue";
import { apiQuery } from "@/api/j24api";
import { get } from "aws-amplify/api";

const headers = [
  { text: "Application Name", value: "appName", sortable: true },
  { text: "Version", value: "version", sortable: true },
  { text: "Release Date", value: "releaseDate", sortable: true },
  //  { text: "SNOW Request", value: "ticketNo" },
  { text: "App Stream", value: "stream", sortable: true },
  { text: "Notes", value: "notes" },
  // { text: "Approve", value: "actions" },
];

const patchesToApprove = reactive([]);
const loading = ref(false);
const selectedTab = ref("list");
const patchSelected = ref({});
const patchSelectedFields = reactive([]);
const screenshots = reactive([]);

const selectPatch = async (patch) => {
  getScreenshot(patch.packageHash, patch.stream);
  patchSelected.value = patch;
  selectedTab.value = "edit";
  patchSelectedFields.length = 0;
  patchSelectedFields.push({ label: "ID", value: patch.id });
  patchSelectedFields.push({ label: "Stream", value: patch.stream });
  patchSelectedFields.push({ label: "App Name", value: patch.appName });
  patchSelectedFields.push({ label: "Version", value: patch.version });
  patchSelectedFields.push({ label: "Package Name", value: patch.packageName });
  patchSelectedFields.push({ label: "Package Hash", value: patch.packageHash });
  patchSelectedFields.push({
    label: "Architecture",
    value: patch.architecture,
  });
  patchSelectedFields.push({
    label: "Release Date",
    value: formatDate(patch.releaseDate),
  });
  patchSelectedFields.push({
    label: "Kill Apps Defined",
    value: areKillAppsDefined(patch.killApps),
  });
};

async function downloadPkg(data) {
  loading.value = true;
  var downloadURL = await apiQuery("ELA", "patching/patchitems", {
    apiAction: "downloadPkg",
    pkgName: data,
  });
  const link = document.createElement("a");
  link.href = downloadURL.url;
  link.download = data;
  link.click();
  loading.value = false;
}

function areKillAppsDefined(killApps) {
  if (killApps.length == 0) {
    return "No";
  }
  for (let i = 0; i < killApps.length; i++) {
    if (killApps[i].appName == "" || killApps[i].bundleId == "") {
      return "No";
    }
    return (
      "Yes - appName " +
      killApps[i].appName +
      " bundleId " +
      killApps[i].bundleId
    );
  }
}

async function getUnapproved() {
  loading.value = true;
  let result = await apiQuery("ELA", "patching/patchingVersions", {
    apiAction: "GetUnapproved",
  });
  if (result.length) {
    patchesToApprove.length = 0;
    patchesToApprove.push(...result);
  }
  loading.value = false;
}

function formatDate(dateInput) {
  try {
    let date = new Date(dateInput).toLocaleString("en-GB");
    console.log(date);
    return date;
  } catch (error) {
    return "";
  }
}
function approveUpdate(item) {
  console.log(item);
  showDialog.value = true;
  patchToApprove.value = item;
}

async function confirmApprove() {
  try {
    loading.value = true;
    let result = await apiQuery("ELA", "patching/patchingVersions", {
      apiAction: "ApproveVersion",
      patch: patchToApprove.value,
    });
  } catch (error) {
    console.log(error);
  }
  getUnapproved();
  selectedTab.value = "list";
  showDialog.value = false;
}

const showDialogReject = ref(false);
const patchToReject = ref({});
async function rejectUpdate(item) {
  showDialogReject.value = true;
  patchToReject.value = item;
}

async function confirmReject() {
  try {
    loading.value = true;
    let result = await apiQuery("ELA", "patching/patchingVersions", {
      apiAction: "RejectVersion",
      patch: patchToReject.value,
    });
  } catch (error) {
    console.log(error);
  }
  getUnapproved();
  showDialogReject.value = false;
}

const showDialogNotes = ref(false);
const patchToNote = ref({});
const patchNote = ref("");

async function addNote() {
  loading.value = true;
  patchToNote.value.note = patchNote.value;
  await apiQuery("ELA", "patching/patchingVersions", {
    apiAction: "AddNote",
    patch: patchToNote.value,
  });
  await getUnapproved();
  showDialogNotes.value = false;
  patchNote.value = "";
  patchSelected.value = patchesToApprove.find(
    (patch) => patch._id == patchToNote.value._id
  );
}

async function getScreenshot(md5, stream) {
  loading.value = true;
  screenShotsExpanded.value = false;
  screenshots.length = 0;
  let result = await apiQuery("ELA", "patching/patchingVersions", {
    apiAction: "GetScreenshot",
    md5: md5,
    stream: stream,
  });
  if (result.length) {
    screenshots.push(...result);
  }
  console.log(result);
  loading.value = false;
}

onMounted(() => {
  getUnapproved();
});

const showDialog = ref(false);
const patchToApprove = ref({});

const selectImage = ref(false);
const selectedImage = ref("");
const screenShotsExpanded = ref(false);
</script>

<template>
  <v-dialog v-model="selectImage">
    <v-card append-icon="mdi-close" @click="selectImage = false">
      <v-card-text>
        <v-img :src="selectedImage"> </v-img>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showDialogReject" max-width="500">
    <v-card>
      <v-card-title>Confirm Reject Patch</v-card-title>
      <v-card-text>
        Please confirm you wish to reject this version. It will be removed from
        the patch definitions
      </v-card-text>
      <v-card-actions>
        <v-btn variant="tonal" @click="showDialogReject = false">Cancel</v-btn>
        <v-btn variant="tonal" :loading="loading" @click="confirmReject"
          >Reject</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showDialogNotes" max-width="500">
    <v-card>
      <v-card-title>Add Note</v-card-title>
      <v-card-text>
        <v-textarea
          v-model="patchNote"
          label="Note"
          outlined
          rows="3"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn
          variant="tonal"
          @click="
            showDialogNotes = false;
            patchNote = '';
          "
          >Cancel</v-btn
        >
        <v-btn variant="tonal" @click="addNote" :loading="loading"
          >Add Note</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-window v-model="selectedTab">
    <v-window-item value="list">
      <h2>Pending Approvals</h2>
      <v-card>
        <v-card-text>
          <EasyDataTable
            :headers="headers"
            :items="patchesToApprove"
            :loading="loading"
            alternating
            theme-color="#e7541e"
            @click-row="selectPatch"
          >
            <template #item-releaseDate="item">
              {{ formatDate(item.releaseDate) }}
            </template>
            <template #item-notes="item">
              <v-btn v-if="item.notes" icon size="small" variant="text">
                <v-icon>mdi-note</v-icon>
                <v-tooltip activator="parent"
                  >Last Note: {{ item.notes[0].note }}</v-tooltip
                >
              </v-btn>
            </template>

            <template #item-actions="item">
              <v-row>
                <v-col cols="auto">
                  <v-btn
                    size="x-small"
                    color="success"
                    prepend-icon="mdi-check"
                    @click="approveUpdate(item)"
                    >Approve</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    size="x-small"
                    color="warning"
                    prepend-icon="mdi-note"
                    @click="
                      showDialogNotes = true;
                      patchToNote = item;
                    "
                    >Add Note</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    size="x-small"
                    color="error"
                    prepend-icon="mdi-close"
                    @click="rejectUpdate(item)"
                    >Reject</v-btn
                  >
                </v-col>
              </v-row>
            </template>
          </EasyDataTable>
        </v-card-text>
      </v-card>
    </v-window-item>

    <v-window-item value="edit" class="pa-1">
      <v-card max-width="800" class="pa-2" :loading="loading">
        <v-card-title>
          <v-row class="py-2">
            <v-col cols="auto">
              <v-btn
                @click="selectedTab = 'list'"
                prepend-icon="mdi-arrow-left-bold"
                >Back</v-btn
              >
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto"><h3>Patch Version Approval</h3></v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" v-for="patch in patchSelectedFields" :key="patch">
              <v-text-field
                variant="underlined"
                readonly
                v-model="patch.value"
                :label="patch.label"
                density="compact"
                hide-details
            /></v-col>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-btn
                size="small"
                color="success"
                prepend-icon="mdi-check"
                @click="approveUpdate(patchSelected)"
                >Approve</v-btn
              >
            </v-col>
            <v-col cols="auto">
              <v-btn
                size="small"
                color="error"
                prepend-icon="mdi-close"
                @click="rejectUpdate(patchSelected)"
                :disabled="patchSelected.notes ? false : true"
                >Reject
              </v-btn>
              <v-tooltip v-if="!patchSelected.notes" activator="parent"
                >Add a note for the reason to reject</v-tooltip
              >
            </v-col>
            <v-col cols="auto">
              <v-btn
                size="small"
                color=""
                prepend-icon="mdi-note"
                @click="
                  showDialogNotes = true;
                  patchToNote = patchSelected;
                "
                >Add Note</v-btn
              >
            </v-col>
            <v-col cols="auto">
              <v-btn
                :loading="loading"
                size="small"
                prepend-icon="mdi-download"
                @click="downloadPkg(patchSelected.packageName)"
                >Download Pkg</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="screenshots.length">
            <v-col cols="12">
              <v-card>
                <v-card-title
                  @click="screenShotsExpanded = !screenShotsExpanded"
                >
                  <v-icon>{{
                    screenShotsExpanded ? "mdi-menu-down" : "mdi-menu-right"
                  }}</v-icon
                  >Screenshots
                  {{ "(" + screenshots.length + ")" }}</v-card-title
                >
                <v-card-text v-if="screenShotsExpanded">
                  <template v-for="screenshot in screenshots" :key="screenshot">
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="auto"
                        >Built by {{ screenshot.serial }} -
                        {{ formatDate(screenshot.LastModified) }}</v-col
                      >
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-img
                          :src="screenshot.url"
                          @click="
                            selectImage = true;
                            selectedImage = screenshot.url;
                          "
                        ></v-img>
                      </v-col>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="patchSelected.notes">
            <v-col cols="12" v-for="note in patchSelected.notes" :key="note">
              <v-card :subtitle="formatDate(note.timestamp) + ' ' + note.user">
                <v-card-text>{{ note.note }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-window-item>
  </v-window>

  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-card-title>Confirm Approve Patch</v-card-title>
      <v-card-text>
        Please confirm to approve this version. After approving it will be
        deployed.
        <v-table class="mt-2">
          <tr class="text-left">
            <th>App</th>
            <th>Version</th>
          </tr>
          <tr>
            <td>{{ patchToApprove.appName }}</td>
            <td>{{ patchToApprove.version }}</td>
          </tr>
        </v-table>
        <v-checkbox
          label="Confirm"
          v-model="patchToApprove.confirmed"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions
        ><v-btn variant="tonal" @click="showDialog = false">Cancel</v-btn
        ><v-btn
          :loading="loading"
          v-if="patchToApprove.confirmed"
          variant="tonal"
          @click="confirmApprove()"
          >Submit</v-btn
        ></v-card-actions
      >
    </v-card>
  </v-dialog>
</template>
